export const mobileMediaQuery = () => {
  return {query: '(max-width: 768px)'}
}

export const tabletVerticalMediaQuery = () => {
  return {query: '(min-width: 769px) and (max-width: 1024px)'}
}

export const tabletHorizontalMediaQuery = () => {
  return {query: '(min-width: 1025px)'}
}

